import React, { Component } from "react";
import PropsType from "prop-types";
import _ from "lodash";
import { Accessor, ColorX, FilterX, IconX, LocaleX, ZFunc } from "IZOX/STATIC";
import { XInput, XScroll, HStack, VStack, XButton, XText } from "IZOX/_X";
import styles from "./_style/popuplistselector";
import OperBar from "../OperBar/OperBar";

/**
 * @augments {Component<Props, State>}
 */
class PopupListSelector extends Component {

  static propTypes = {
    choices: PropsType.array,
    onConfirm: PropsType.func,
    onCancel: PropsType.func,
    onSelect: PropsType.func,
    onUnselect: PropsType.func,
    renderer: PropsType.func,
    filterFunc: PropsType.func,
    allowSearch: PropsType.bool,
    style: PropsType.any,
    hoverBgColor: PropsType.string,
    selectCap: PropsType.string,
    selectVal: PropsType.string,
    searchFields: PropsType.arrayOf(PropsType.string),
    addOns: PropsType.any,
    multiple: PropsType.any,
    defaultValue: PropsType.array,
    listHeight: PropsType.any,
    popupWidth: PropsType.any,
  }

  static defaultProps = {
    choices: [],
    onConfirm: null,
    onCancel: null,
    onSelect: null,
    onUnselect: null,
    renderer: null,
    filterFunc: null,
    allowSearch: false,
    style: {},
    hoverBgColor: ColorX.CSS("gambot2Blue", 0.2),
    selectCap: "cap",
    selectVal: "val",
    searchFields: [],
    addOns: {},
    multiple: false,
    defaultValue: null,
    listHeight: 300,
    popupWidth: 250
  }

  constructor(){
    super();  
    this.state = {
      search: "",
      selected: []
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      let {defaultValue, selectVal} = this.props;
      if(!defaultValue) return;
      let selected = _.map(defaultValue, o => Accessor.Get(o, selectVal));
      this.setState({
        selected: selected
      });
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PopupListSelector.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _select = (choice) => {
    let {onSelect, onUnselect, selectVal, multiple} = this.props;
    let {selected} = this.state;

    let val = Accessor.Get(choice, selectVal);

    if(multiple && selected.includes(val)){
      selected = _.filter(selected, o => o !== val);
      this.setState({
        selected: selected
      }, () => {
        onUnselect?.(choice);
      });
    }else{
      if(!multiple){
        selected = [val];
      }else{
        selected.push(val);
      }
      this.setState({
        selected: selected
      }, () => {
        onSelect?.(choice);
      });
    }
  }

  _onSearchTextChange = (text) => {
    this.setState({
      search: text
    });
  }

  _onOperConfirm = () => {
    let {onConfirm, choices, selectVal} = this.props;
    let {selected} = this.state;

    let selectedChoices = _.filter(choices, o => {
      let val = Accessor.Get(o, selectVal);
      return selected.includes(val);
    });

    onConfirm?.(selectedChoices);
  }

  _onOperCancel = () => {
    let {onCancel} = this.props;
    onCancel?.();
  }

  defaultFilterFunc = (choice, search) => {
    let {searchFields} = this.props;
    return FilterX.TextSearchForFields(choice, 
      searchFields, search);
  }

  renderDefault = (choice, isSelected) => {
    let {selectCap, addOns} = this.props;
    let caption = Accessor.Get(choice, selectCap);
    caption = ZFunc.IfFuncExec(caption, addOns);
    return (
      <HStack style={{
        padding: 10, 
        backgroundColor: ColorX.CSS(isSelected? "aliceblue": "pureWhite")
      }}>
        <XText style={{textAlign: "center", flex: 1}}>
          {LocaleX.Parse(caption)}
        </XText>
        <HStack style={{ width: 50 }}>
          {isSelected && 
            IconX.Get("feather", "check", 16, ColorX.CSS("gambotBlue"))}
        </HStack>
      </HStack>
    );
  }

  renderChoiceBtn(choice, idx){
    let {selected} = this.state;
    let {renderer, hoverBgColor, selectVal} = this.props;
    let _renderer = renderer ?? this.renderDefault;
    let val = Accessor.Get(choice, selectVal);
    let isSelected = selected.includes(val);
    return (
      <XButton key={idx} notInjectColor
        style={{width: "100%", padding: 0}} 
        hoverBgColor={hoverBgColor}
        onPress={() => this._select(choice)}>
        {_renderer?.(choice, isSelected)}
      </XButton>
    );
  }

  renderChoices(){
    let {search} = this.state;
    let {choices, filterFunc, allowSearch, listHeight} = this.props;
    let _choices = choices;
    let _filterFunc = filterFunc ?? this.defaultFilterFunc;
    if(allowSearch && _filterFunc && !_.isEmpty(search)){
      _choices = _.filter(choices, o => {
        try {
          return _filterFunc?.(o, search) ?? true;
        }catch{ return false; }
      });
    }
    return (
      <XScroll style={{ 
        maxHeight: listHeight, 
        height: allowSearch && _filterFunc ? 200 : "auto",
        width: "100%",
        flexGrow: 0
      }}>
        {_.map(_choices, (o, i) => {
          return this.renderChoiceBtn(o, i);
        })}
      </XScroll>
    );
  }

  renderAutoComplete(){
    let {search} = this.state;
    let {allowSearch} = this.props;
    if(!allowSearch) return;
    return (
      <HStack style={styles.header}>
        <HStack style={styles.acbox} spacing={10}>
          {IconX.Get("awesome", "search", 20, ColorX.CSS("gambotBlue"))}
          <XInput style={styles.actextinput} value={search}
            onChangeText={this._onSearchTextChange}
            />
        </HStack>
      </HStack>
    );
  }

  renderOper(){
    let {multiple} = this.state;
    if(!multiple) return;
    return (
      <OperBar
        borderRadius={15}
        onConfirm={this._onOperConfirm}
        onCancel={this._onOperCancel}
        buttons={["Cancel", "Confirm"]}
        />
    );
  }

  render(){
    let {style, popupWidth} = this.props;
    return (
      <VStack style={{
        backgroundColor: ColorX.CSS("pureWhite"),
        borderRadius: 15,
        maxWidth: "70%",
        minWidth: popupWidth,
        ...style
      }} onClick={(e) => e.stopPropagation()}>
        <VStack style={{padding: 5, width: "100%"}}>
          {this.renderAutoComplete()}
          {this.renderChoices()}
        </VStack>
        {this.renderOper()}
      </VStack>
    );
  }

}

export default PopupListSelector;
